// extracted by mini-css-extract-plugin
export default {"last_updated__container":"LastUpdated_last_updated__container__asp9o","aspiringTag":"LastUpdated_aspiringTag__OjjxM","aspiringLine":"LastUpdated_aspiringLine__cqTLE"};